import React from 'react';
import { InputGroup, Form } from 'react-bootstrap5';

import searchIcon from 'images/new_ui/icons/search.svg';
import { useTableContext } from '../TableContext';
import Actions from '../Actions';

export default function SearchFilter() {
  const { state, dispatch } = useTableContext();
  const filterValue = state.searchFilter;

  return (
    <InputGroup>
      <InputGroup.Text>
        <img src={searchIcon} alt="Search Icon" width="24px" height="24px" />
      </InputGroup.Text>
      <Form.Control
        placeholder="Type here..."
        value={filterValue}
        onChange={(e) => Actions.search(dispatch, e.target.value)}
      />
    </InputGroup>
  );
}
